var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_vm._t("default"),(_vm.isOverlayVisible)?_c('div',{staticClass:"overlay",on:{"click":_vm.showEditingDisabledAlert}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }